import { getLanguageFromStorage } from "syf-js-utilities";
export var cleanUpPortfolioName = function (name) {
    return name.toLocaleLowerCase().replaceAll(" ", "-");
};
export var getPolicyValue = function (_a) {
    var _b, _c, _d, _e;
    var privacyPolicies = _a.privacyPolicies, clientId = _a.clientId, accountType = _a.accountType;
    var lang = getLanguageFromStorage();
    var pdfFileNameEnglish = (_c = (_b = privacyPolicies === null || privacyPolicies === void 0 ? void 0 : privacyPolicies[clientId]) === null || _b === void 0 ? void 0 : _b[accountType]) === null || _c === void 0 ? void 0 : _c.en;
    var pdfFileNameSpanish = (_e = (_d = privacyPolicies === null || privacyPolicies === void 0 ? void 0 : privacyPolicies[clientId]) === null || _d === void 0 ? void 0 : _d[accountType]) === null || _e === void 0 ? void 0 : _e.es;
    if (lang === "en" && pdfFileNameEnglish) {
        return "en/".concat(pdfFileNameEnglish);
    }
    if (lang === "en" && !pdfFileNameEnglish && pdfFileNameSpanish) {
        return "es/".concat(pdfFileNameSpanish);
    }
    if (lang === "es" && pdfFileNameSpanish) {
        return "es/".concat(pdfFileNameSpanish);
    }
    if (lang === "es" && !pdfFileNameSpanish && pdfFileNameEnglish) {
        return "en/".concat(pdfFileNameEnglish);
    }
    return undefined;
};
var getPrivacyPolicyPdfName = function (_a) {
    var _b, _c, _d, _e, _f;
    var accountSummary = _a.accountSummary, privacyPolicies = _a.privacyPolicies;
    var accountType = (_b = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _b === void 0 ? void 0 : _b.type;
    var lineOfBusiness = (_c = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _c === void 0 ? void 0 : _c.lineOfBusiness;
    var portfolio = (_d = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _d === void 0 ? void 0 : _d.portfolio;
    var accountSummaryClientId = (_f = (_e = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _e === void 0 ? void 0 : _e.clientId) === null || _f === void 0 ? void 0 : _f.toLocaleLowerCase();
    if (!privacyPolicies ||
        !accountType ||
        !accountSummaryClientId ||
        !lineOfBusiness) {
        return undefined;
    }
    var policyValueProps = {
        privacyPolicies: privacyPolicies,
        clientId: accountSummaryClientId,
        accountType: accountType,
    };
    // Logic for non RETAIL CARDS
    if (lineOfBusiness !== "RETAIL_CARD" && portfolio) {
        var cleanedPortfolio = cleanUpPortfolioName(portfolio);
        policyValueProps.clientId = "".concat(accountSummaryClientId, "-").concat(cleanedPortfolio);
    }
    // We try to get the PDF name
    var privacyPolicyValue = getPolicyValue(policyValueProps);
    // If not privacyPolicyValue and is a PSCC account and clientId is paysol we should get the default Paysol Privacy Policy
    if (!privacyPolicyValue &&
        lineOfBusiness === "PAYMENT_SOLUTIONS_CARECREDIT" &&
        portfolio) {
        policyValueProps.clientId = "paysol";
        privacyPolicyValue = getPolicyValue(policyValueProps);
    }
    return privacyPolicyValue;
};
export default getPrivacyPolicyPdfName;
